const errors = {
  images: {
    maxReach: 'Vous ne pouvez pas ajouter plus d\'images du type {type}'
  },
  menu: {
    fetch: 'Une erreur est survenue en recherchant les menus disponibles'
  }
}

export default errors
